import React from "react";

import DeprecatedInput from "@v1/components/common/designSystem/Input";
import DeprecatedIconButton from "@v1/components/designSystem/button/IconButton";
import { Send } from "lucide-react";

import useBuildAssistantPromptKeyDown from "./useBuildAssistantPromptKeyDown";

interface MinimizedBuildAssistantPromptProps {
  prompt: string;
  setPrompt: (prompt: string) => void;
  placeholderText: string;
  onSubmit: () => void;
  isGenerating: boolean;
  inputRef?: React.RefObject<HTMLInputElement>;
}

export const MinimizedBuildAssistantPrompt: React.FC<
  MinimizedBuildAssistantPromptProps
> = ({
  prompt,
  setPrompt,
  placeholderText,
  onSubmit,
  isGenerating,
  inputRef,
}) => {
  const handleKeyDown = useBuildAssistantPromptKeyDown(
    prompt,
    isGenerating,
    onSubmit,
  );

  return (
    <div className="flex w-full items-center gap-3 bg-white p-3">
      <DeprecatedInput
        type="text"
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
        placeholder={placeholderText}
        disabled={isGenerating}
        ref={inputRef}
        onKeyDown={handleKeyDown}
        size="base"
        unsafe_inputClassName="bg-white"
        unsafe_className="border-0 focus-within:ring-0 bg-white"
        layoutClassName="grow"
      />
      <DeprecatedIconButton
        size="sm"
        variant="primary"
        onClick={onSubmit}
        aria-label="Send"
        icon={<Send size={12} />}
        disabled={prompt === "" || isGenerating}
      />
    </div>
  );
};
